import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=b65d6498&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=b65d6498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65d6498",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b65d6498')) {
      api.createRecord('b65d6498', component.options)
    } else {
      api.reload('b65d6498', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=b65d6498&scoped=true&", function () {
      api.rerender('b65d6498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21Row70tTVJJW/JS/comp/PopupDialog.vue"
export default component.exports